export class MeasurementUnits {
    id: number;
    code: string;
    description: string;
    label: string;

    constructor() {
        this.code = "";
        this.description = "";
        this.label = "";
    }
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/seguridad/emisor/recursos/modelo/MeasurementUnits.ts